export const REVOKE_TOKEN = 'logout/revokeToken';
export const REVOKE_TOKEN_START = 'logout/revokeTokenStart';
export const REVOKE_TOKEN_COMPLETE = 'logout/revokeTokenCompleted';
export const REVOKE_TOKEN_ERROR = 'logout/revokeTokenError';

export const revokeToken = (payload = {}) => ({
  type: REVOKE_TOKEN,
  payload,
});
